import axios from './axios'
import { Esami,CentriConvenzionatiLaboratoryAnalisi, DiagnosticInvestigation  } from '@/../../EshJSLib/models/patient'


export async function saveEsami(params: Esami) {



    const json = JSON.stringify(params);
   const response = await axios.post(`/api/esami`,json);


    // console.log(params.code);
    return response.data;
}

export async function getEsamiType(tipo: Number) {
    const response = await axios.get(`/api/getEsami/${tipo}`) ;
    return response.data.data as Esami[];
}

export async function getCentriIndagini(tipo: Number) {
    const response = await axios.get(`/api/getCentriIndagini/${tipo}`) ;
    return response.data.data as CentriConvenzionatiLaboratoryAnalisi[];
}


export async function updateEsami(params:Esami) {
    const response = await axios.put(`/api/esami/${params.id_indagine}`,params);

    return response.data;
}

export async function deleteEsami(id: Number) {
    const response = await axios.delete(`/api/esami/${id}`);
    return response.data;
}

export async function filterEsamiByName(param: String): Promise<DiagnosticInvestigation[]> {

    const json = JSON.stringify({search: param });
    const response = await axios.post(`/api/esamifilter`, json);
    return response.data.data as DiagnosticInvestigation[];
}


export async function filterEsami(param: String, id: Number): Promise<Esami[]> {


    const json = JSON.stringify({search: param });
    const response = await axios.post(`/api/esamifilter/${id}`, json);
    return response.data.data as Esami[];
}